import Immutable from 'immutable';


const initialState = Immutable.fromJS({
  profile: null,
  accessUrl: null,
  athleteAccessResponse: null
});


module.exports = function(state = initialState, action={}) {
  switch(action.type) {
    case 'SET_PROFILE': {
      return state.set('profile', Immutable.fromJS(action.profile));
    }

    case 'SHARE_GYM_OWNER_ACCESS_URL': {
      return state.set('accessUrl', action.accessUrl);
    }

    case 'SET_ATHLETE_ACCESS_RESP': {
      return state.set('athleteAccessResponse', action.athleteAccessResponse);
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/signupReducer.js